import styles from "./StemCertification.module.css";
import stemorg from "../../assets/images/stemorg.jpg";

const StemCertification = () => {
  return (
    <section className={styles.certification}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.textContent}>
            <h2 className={styles.title}>We are STEM Certified</h2>
            <p className={styles.quote}>
              "Old men can make war, but it is children who will make history."
              - Ray Merritt
            </p>
            <p className={styles.description}>
              STEMx India has been accredited with STEM.org certification for
              its best-in-class products, services, and curriculum. Students
              learning with us will also receive a STEM.org certification.
            </p>
          </div>
          <div className={styles.certificateImage}>
            <img
              src={stemorg}
              alt="STEM.org Certification"
              className={styles.certificate}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default StemCertification;
